import styled from '@emotion/styled';

import { Segment } from '@britishcouncil/react-extro-ui';

export const Root = styled(Segment)`
    padding: 0;
    gap: 0;
    background: transparent;
    border: 1px solid #C8C8C8;

    .ex-segment {
        padding: ${({theme}) => theme.spacing.md} ${({theme}) => theme.spacing.md};
    }
`;
styled(Segment)`
  && {
    padding: 0;
  }
`;
export const Title = styled.div`
  * > {
    margin-bottom: unset;
  }
`;
